module.exports = __webpack_public_path__ + "img/keycap-digit-nine.d66f43a5.png";